import { styled } from "@mui/material";
import HeaderFilter from "components/filter/header/HeaderFilter";
import LayerSetSection from "components/layerSets/LayerSetSection";
import { PaddedPaper } from "components/surfaces/PaddedPaper";

export default function LayerOverviewPage() {
  return (
    <StyledPaddedPaper>
      <HeaderFilter />
      <LayerSetSection />
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
  transition: all 320ms ease-out;
  display: flex;
  flex-direction: column;
`;
